
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleScroll = (id) => {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollToId: id } });
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-[#0d1222]/90 backdrop-blur-md shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center space-x-3">
              <img
                src={`${process.env.PUBLIC_URL}/alethiaSystemsLogoChevrons.png`}
                alt="Aletheia Systems Logo - Identity Verification"
                className="h-10 w-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://placehold.co/40x40/06b6d4/0d1222?text=AS';
                }}
              />
              <span className="text-2xl font-bold text-white tracking-wider">
                Aletheia<span className="text-accent-cyan">Systems</span>
              </span>
            </Link>
          </div>
          <nav className="hidden md:flex space-x-8">
            <button onClick={() => handleScroll('products')} className="text-text-light hover:text-accent-cyan transition duration-300">Products</button>
            <button onClick={() => handleScroll('services')} className="text-text-light hover:text-accent-cyan transition duration-300">Services</button>
            <button onClick={() => handleScroll('about')} className="text-text-light hover:text-accent-cyan transition duration-300">About</button>
            <button onClick={() => handleScroll('contact')} className="text-text-light hover:text-accent-cyan transition duration-300">Contact</button>
            <Link to="/support" className="text-text-light hover:text-accent-cyan transition duration-300">Support</Link>
            <Link to="/fraud-api" className="text-text-light hover:text-accent-cyan transition duration-300">Developers</Link>
          </nav>
          <div className="hidden md:block">
            <Link
              to="/appointment"
              className="bg-primary hover:bg-indigo-600 text-white font-semibold py-2 px-6 rounded-full transition duration-300 shadow-lg shadow-primary/50 inline-block"
            >
              Book a Demo
            </Link>
          </div>
          <button className="md:hidden p-2 rounded-md text-text-light hover:text-accent-cyan focus:outline-none focus:ring-2 focus:ring-accent-cyan">
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
